import { call, put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getServiceIdSelector } from '../../user/selectors'
import { IServiceConfigResponse } from '../store/configurations.types'
import { ConfigurationsService } from '../services/configurations.service'
import * as actions from '../store/configurations.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

export function* setCommandFacilityConfig() {
  const serviceId: string = yield select(getServiceIdSelector)
  const configurationsService = new ConfigurationsService(serviceId)
  try {
    const response: IServiceConfigResponse = yield call([
      configurationsService,
      configurationsService.getCommandFacilityConfig,
    ])
    const { entity } = response
    if (entity && entity.length) yield put(actions.setCommandFacilityConfig(entity[0]))
  } catch (e) {
    yield put(throwPcrException(`setCommandFacilityConfig() error: ${e}`))
  }
}
export function* setCommandFacilityConfigSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], setCommandFacilityConfig)
}
